import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSecurityProduct implements BaseEnumType {
  private static allValues: EnumSecurityProduct[] = []; // make sure this is top-most
  
  public static none = new EnumSecurityProduct(0, "None", "enum_security_product_none");
  public static brewMan = new EnumSecurityProduct(1, "BrewMan", "enum_security_product_brew_man");
  public static accountsLink = new EnumSecurityProduct(2, "AccountsLink", "enum_security_product_accounts_link");
  public static brewRep = new EnumSecurityProduct(3, "BrewRep", "enum_security_product_brew_rep");
  public static production = new EnumSecurityProduct(4, "Production", "enum_security_product_production");
  public static deliveryApp = new EnumSecurityProduct(5, "DeliveryApp", "enum_security_product_delivery_app");
  public static bMArchive = new EnumSecurityProduct(6, "BMArchive", "enum_security_product_b_m_archive");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSecurityProduct.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumSecurityProduct.none; }
  public isBrewMan() { return this === EnumSecurityProduct.brewMan; }
  public isAccountsLink() { return this === EnumSecurityProduct.accountsLink; }
  public isBrewRep() { return this === EnumSecurityProduct.brewRep; }
  public isProduction() { return this === EnumSecurityProduct.production; }
  public isDeliveryApp() { return this === EnumSecurityProduct.deliveryApp; }
  public isBMArchive() { return this === EnumSecurityProduct.bMArchive; }

  public static getValues(): readonly EnumSecurityProduct[] {
    return EnumSecurityProduct.allValues;
  }

  public static getValuesExcept0(): readonly EnumSecurityProduct[] {
    return EnumSecurityProduct.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSecurityProduct {
    const found = EnumSecurityProduct.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSecurityProduct - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSecurityProduct): EnumSecurityProduct {
    const found = name ? EnumSecurityProduct.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSecurityProduct - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSecurityProduct>): boolean {
    return this.key === other?.key;
  }
}